/**
 * '2026-07' → 'jul 2026'. Anything that isn't a month key yields an empty
 * label: a coerced value rendered as 'jan 1900', and a wrong date reads as real.
 *
 * @param {string} monthKey - 'YYYY-MM'
 * @returns {string}
 */
const formatMonthLabel = (monthKey) => {
    if (!/^\d{4}-\d{2}$/.test(String(monthKey))) return ''
    const [y, m] = String(monthKey).split('-').map(Number)
    const date = new Date(y, m - 1, 1)
    return new Intl.DateTimeFormat('nl-NL', { month: 'short', year: 'numeric' }).format(date)
}

export default formatMonthLabel
